import {
  CraApiResponse,
  GETInstrumentosFilterParams,
  CadastroCraApiRequest,
  SolicitarLiquidacaoRequest,
  HistoricoResponse,
  CommandResultTyped,
} from 'common/genericTypes';
import { Dispatch } from 'redux';
import {
  GETCraDetalhes,
  GETCras,
  POSTCra,
  PUTCra,
  GETCraDocumentDownloadUrl,
  POSTInterOpCra,
  POSTEnviarLiquidacao,
  GETHistoricoCra,
  POSTConfirmarLiquidacaoCra,
  PUTUploadDoc as PUTUploadDocCra,
  DELETEUploadDoc as DELETEUploadDocCra,
  GETCraByInstrumentoId,
  PUTCraAditamento,
  PUTEditarCra,
  GETAditamentoCra,
  PUTAditamentoCra
} from 'requests/cra';
import { UploadDocResponse } from '../models/uploadDocResponse';
import { typedAction } from 'store/modules/base';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export interface CraApiState {
  getCraDetalhes(dispatch: Dispatch, id: string, stackRequest?: boolean): Promise<CraApiResponse>;
  getCras(
    dispatch: Dispatch,
    params?: GETInstrumentosFilterParams,
    stackRequest?: boolean
  ): Promise<Array<CraApiResponse>>;
  getCraByInstrumentoId(dispatch: Dispatch, instrumentoId: string, stackRequest?: boolean): Promise<CraApiResponse>;
  postCra(dispatch: Dispatch, cra: CadastroCraApiRequest, stackRequest?: boolean): Promise<CraApiResponse>;
  putCra(
    dispatch: Dispatch,
    craId: string,
    cra: CadastroCraApiRequest,
    stackRequest?: boolean
  ): Promise<CraApiResponse>;
  putCraAditamento(
    dispatch: Dispatch,
    CraId: string,
    Cra: CadastroCraApiRequest,
    date: string,
    document: File,
    stackRequest?: boolean
  ): Promise<string>;
  putEditarCra(
    dispatch: Dispatch,
    craId: string,
    cra: CadastroCraApiRequest,
    justificativa: string,
    document?: File | undefined,
    stackRequest?: boolean
  ): Promise<CommandResultTyped<string>>;
  putUploadDoc(
    dispatch: Dispatch,
    craId: string,
    emissionType: string,
    file: File,
    stackRequest?: boolean
  ): Promise<Array<UploadDocResponse>>;
  deleteUploadDoc(dispatch: Dispatch, craId: string, craDocumentId: string, stackRequest?: boolean): Promise<unknown>;
  getCraDocumentDownloadUrl(
    dispatch: Dispatch,
    craId: string,
    craDocumentId: string,
    stackRequest?: boolean
  ): Promise<string>;
  postInterOpCra(dispatch: Dispatch, cra: CadastroCraApiRequest, stackRequest?: boolean): Promise<CraApiResponse>;
  postEnviarLiquidacao(
    dispatch: Dispatch,
    craId: string,
    craSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
    stackRequest?: boolean
  ): Promise<CraApiResponse>;
  postConfirmarLiquidacaoCra(dispatch: Dispatch, craId: string, precoUnitarioLiquidacao: number, stackRequest?: boolean): Promise<CraApiResponse>;
  getHistoricoCra(dispatch: Dispatch, craId: string, stackRequest?: boolean): Promise<Array<HistoricoResponse>>;
  getAditamentoCra(dispatch: Dispatch, aditamentoId: string, stackRequest?: boolean): Promise<AditamentoRevisionData>;
  putAditamentoCra(dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest?: boolean): Promise<Array<AditamentoDiferenca>>;
}

export const craApiInicialState: CraApiState = {
  getCraDetalhes: GETCraDetalhes,
  getCras: GETCras,
  getCraByInstrumentoId: GETCraByInstrumentoId,
  postCra: POSTCra,
  putCra: PUTCra,
  putEditarCra: PUTEditarCra,
  putCraAditamento: PUTCraAditamento,
  putUploadDoc: PUTUploadDocCra,
  deleteUploadDoc: DELETEUploadDocCra,
  getCraDocumentDownloadUrl: GETCraDocumentDownloadUrl,
  postInterOpCra: POSTInterOpCra,
  postEnviarLiquidacao: POSTEnviarLiquidacao,
  postConfirmarLiquidacaoCra: POSTConfirmarLiquidacaoCra,
  getHistoricoCra: GETHistoricoCra,
  getAditamentoCra: GETAditamentoCra,
  putAditamentoCra: PUTAditamentoCra,
};

enum CraApiActionType {
  Update = 'craApi/UPDATE',
  Reset = 'craApi/RESET',
}

export const updateCraApi = (state: CraApiState) => {
  return typedAction(CraApiActionType.Update, state);
};

export const resetCraApi = () => {
  return typedAction(CraApiActionType.Reset);
};

type CraApiAction = ReturnType<typeof updateCraApi | typeof resetCraApi>;

export function craApiReducer(state: CraApiState = craApiInicialState, action: CraApiAction): CraApiState {
  switch (action.type) {
    case CraApiActionType.Update:
      return { ...action.payload };
    case CraApiActionType.Reset:
      return { ...craApiInicialState };
    default:
      return state;
  }
}
